import moment from 'moment-timezone';

const joinTimeAndDate = (time, date, timezone = moment.tz.guess()) =>
  moment.tz(`${date} ${time}`, timezone).isValid()
    ? moment.tz(`${date} ${time}`, timezone)
    : moment.tz(timezone);

export default joinTimeAndDate;
